<script>
import { ObjectManagers } from '@/config'

import SingleSelectFilter from './SingleSelectFilter.vue'

export default {
  name: 'RVBObjectManagerFilter',
  mixins: [SingleSelectFilter],
  computed: {
    options() {
      return ObjectManagers.map(option => {
        return {
          value: option,
          text: option,
        }
      })
    },
  },
}
</script>
